import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgEyeOpen = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 11.7333C5.12304 11.7333 2.69815 10.2633 1.1693 8.00002C2.69815 5.73672 5.12304 4.26668 8 4.26668C10.8769 4.26668 13.3019 5.73672 14.8307 8.00002C13.3019 10.2633 10.8769 11.7333 8 11.7333ZM8 3.20001C4.59505 3.20001 1.76682 5.02015 0.0810669 7.71736C-0.0270227 7.89031 -0.0270223 8.10975 0.0810682 8.28269C1.76682 10.9799 4.59505 12.8 8 12.8C11.4049 12.8 14.2332 10.9799 15.9189 8.28269C16.027 8.10975 16.027 7.89031 15.9189 7.71736C14.2332 5.02015 11.4049 3.20001 8 3.20001ZM8 10.1333C9.17821 10.1333 10.1333 9.17822 10.1333 8.00001C10.1333 6.8218 9.17821 5.86668 8 5.86668C6.82179 5.86668 5.86667 6.8218 5.86667 8.00001C5.86667 9.17822 6.82179 10.1333 8 10.1333Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgEyeOpen)
const IconSvgEyeOpen = createIcon(ForwardRef, 'SvgEyeOpen')
export default IconSvgEyeOpen
